import { Field } from '@sitecore-jss/sitecore-jss-vue';

export function mapFieldToEnum<T extends Record<string, string>>(
  enumObj: T,
  field?: Field<string>
): T[keyof T] | undefined {
  if (!field?.value) return undefined;

  const lower = field.value.toLowerCase();

  for (const key in enumObj) {
    const enumValue = enumObj[key];
    if (typeof enumValue === 'string' && enumObj[key].toLowerCase() === lower) {
      return enumValue;
    }
  }

  return undefined;
}
